export var DeleteError;
(function (DeleteError) {
    DeleteError["customized-report-unable-to-delete"] = "customized-report-unable-to-delete";
})(DeleteError || (DeleteError = {}));
var DeleteRequest = /** @class */ (function () {
    function DeleteRequest(id) {
        this.knownErrorCodes = Object.values(DeleteError);
        this.method = 'delete';
        this.path = "my/customized-reports/".concat(id);
    }
    return DeleteRequest;
}());
export { DeleteRequest };
